import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 12538408-E644-4222-84BF-9A64670E9187
 * name home-lightning-bolt-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lightning-bolt-outline.svg
 * tags
 * - Home Automation 
 */
export const HomeLightningBoltOutlineIcon = createSvgIcon(<><path d="M5 20V12H2L12 3L22 12H19V20H5M12 5.69L7 10.19V18H17V10.19L12 5.69M11.5 18V14H9L12.5 7V11H15L11.5 18Z" /></>, 'HomeLightningBoltOutlineIcon');
export default HomeLightningBoltOutlineIcon